<div class="modal-header">
  <h4 class="modal-title" translate>Signal event data preview</h4>
  <button (click)="onClose()" aria-label="Close" class="close" type="button">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body">
  <div [innerHTML]="htmlDetails">

  </div>
</div>
<div class="modal-footer">
  <div class="modal-footer-inner">
    <div class="row align-items-center flex-fill">
      <div class="col"></div>
      <div class="col-auto">
        <button (click)="onClose()" class="btn btn-outline-primary mr-2" type="button">
          <span translate>Close</span></button>

      </div>
    </div>
  </div>
</div>
